import Cookies from 'js-cookie'

import { USER_AUTHORITIES } from 'modules/user/user.constants'
import {
  COOKIE_INTEGRATION_BACKOFFICE,
  COOKIE_INTEGRATION_BW_CENTRAL,
  COOKIE_INTEGRATION_NAME,
  LOCALSTORAGE_TOKEN_NAME
} from 'modules/auth/auth.constants'
import { UserVO } from 'modules/user'
import { addSignupRole } from './preroutes.services'
import { APP_ROUTES } from './routes.constants'
import { sendToGaWhenUserCompleteTheSignUp } from './preroutes.metric-events'

const appName = require('../../../package.json').name

export const checkAndAddSignupRole = ({ authorities, userId }) => {
  if (!authorities || !userId) {
    return void 0
  }

  const canAddSinupRole =
    authorities &&
    (authorities.includes(USER_AUTHORITIES.USER_PRODUCER) || authorities.includes(USER_AUTHORITIES.USER_SELER)) &&
    !authorities.includes(USER_AUTHORITIES.USER_PLATFORM_SIGNUP)

  if (canAddSinupRole) {
    sendToGaWhenUserCompleteTheSignUp({ userId })
    addSignupRole(userId)
  }

  return void 0
}

export const getParamsTos = (language, canUseTosApiV2) => {
  const params = {
    bearerAuth: `Bearer ${localStorage.getItem(LOCALSTORAGE_TOKEN_NAME)}`,
    language: language ?? 'en',
    acceptCallback: () => {
      window.location.reload()
    },
    isProduction: process.env.NODE_ENV === 'production',
    tosProject: 'HOTMART',
    tosType: 'GDPR',
    apiVersion: 'v1',
    appName
  }

  if (canUseTosApiV2) {
    params.tosType = ''
    params.apiVersion = 'v2'
  }

  return params
}

export const checkToRedirectOnboarding = (hasSignupRole): boolean => {
  const redirectToOnboarding = hasSignupRole === false && window.location.pathname !== APP_ROUTES.onboarding

  return redirectToOnboarding
}

export const setData = () => {
  const cookieBackoffice = Cookies.get(COOKIE_INTEGRATION_BACKOFFICE)
  const cookieTobeUsedAsValue = Cookies.get(COOKIE_INTEGRATION_BW_CENTRAL) || Cookies.get(COOKIE_INTEGRATION_NAME)

  if (cookieBackoffice || !cookieTobeUsedAsValue) {
    localStorage.removeItem(LOCALSTORAGE_TOKEN_NAME)
  }

  if (cookieTobeUsedAsValue) {
    const localStorageTokenName = localStorage.getItem(LOCALSTORAGE_TOKEN_NAME)

    if (localStorageTokenName !== cookieTobeUsedAsValue || !localStorageTokenName) {
      const hmVlcIntegration = encodeURIComponent(cookieTobeUsedAsValue)

      localStorage.setItem(LOCALSTORAGE_TOKEN_NAME, hmVlcIntegration)
    }
  }
}

export const registerSignup = (user: UserVO) => {
  if (user && user.id) {
    const userId = Number(user.id)

    if (window && window.registerUserSignup) {
      window.registerUserSignup(userId)
    } else {
      window.hotDataLayer = window.hotDataLayer || []
      window.hotDataLayer.push({
        type: 'registerUserSignup',
        userId
      })
    }
  }
}
